import { actionTypes } from '../../constants/actionTypes';

const initState = {
    data: [],
    error: null,
    loading: true,
    total: 0
};

export default function (state = initState, action) {
    const {type, payload} = action;
    switch (type) {
        case actionTypes.FETCH_WP_TAGS_STORE: {
            return Object.assign({}, state, {data: [], loading: true, total: 0});
        }

        case actionTypes.FETCH_WP_TAGS_STORE_SUCCESS:
        case actionTypes.FETCH_WP_TAGS_STORE_FAIL: {
            return Object.assign({}, state, payload);
        }

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/stores/tagsStoreWP.tsx